(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = 'skrRecentSearches';
    const readRecent = () => {
      try {
        const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return Array.isArray(value) ? value.filter((item) => typeof item === 'string').slice(0, 6) : [];
      } catch {
        return [];
      }
    };

    const writeRecent = (items) => {
      try {
        localStorage.setItem(storageKey, JSON.stringify(items.slice(0, 6)));
      } catch {
        return;
      }
    };

    const renderRecent = (root) => {
      const list = root.querySelector('[data-skr-recent-list]');
      if (!list) return;
      const emptyText = list.querySelector('[data-skr-recent-empty]')?.textContent || '';
      const items = readRecent();
      list.innerHTML = '';
      if (!items.length) {
        const empty = document.createElement('span');
        empty.className = 'skr-search__muted';
        empty.dataset.skrRecentEmpty = '';
        empty.textContent = emptyText;
        list.appendChild(empty);
        return;
      }
      items.forEach((term) => {
        const link = document.createElement('a');
        const params = new URLSearchParams({ q: term });
        link.href = (window.routes?.search_url || '/search') + '?' + params.toString();
        link.textContent = term;
        list.appendChild(link);
      });
    };

    document.querySelectorAll('.skr-search').forEach((root) => {
      if (root.dataset.skrSearchReady === 'true') return;
      root.dataset.skrSearchReady = 'true';
      const form = root.querySelector('[data-skr-search-form]');
      const input = form?.querySelector('input[type="search"]');
      const emptyState = root.querySelector('[data-skr-search-empty]');
      const clear = root.querySelector('[data-skr-search-clear]');
      if (!form || !input || !emptyState) return;

      const syncEmptyState = () => {
        emptyState.hidden = input.value.trim().length > 0;
      };

      renderRecent(root);
      syncEmptyState();
      input.addEventListener('input', syncEmptyState);
      form.addEventListener('reset', () => window.setTimeout(syncEmptyState, 0));
      form.addEventListener('submit', () => {
        const term = input.value.trim();
        if (!term) return;
        writeRecent([term, ...readRecent().filter((item) => item.toLowerCase() !== term.toLowerCase())]);
      });
      clear?.addEventListener('click', () => {
        writeRecent([]);
        renderRecent(root);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["samenkr-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('skr-upsell')) {
    customElements.define('skr-upsell', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        const form = this.closest('form');
        if (!form) return;
        this.abortController = new AbortController();
        this.querySelector('fieldset').disabled = false;
        this.addEventListener('change', () => {
          const selected = this.querySelector('input[type="radio"]:checked');
          const label = this.querySelector('[data-choice-label]');
          if (label) label.textContent = selected?.dataset.label || label.dataset.defaultLabel;
        }, { signal: this.abortController.signal });
        form.addEventListener('submit', async (event) => {
          const selected = this.querySelector('input[type="radio"]:checked');
          if (!selected?.value) return;
          event.preventDefault();
          if (this.busy) return;
          const id = form.querySelector('[name="id"]')?.value;
          const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
          const button = form.querySelector('[data-add]');
          if (!id || !Number.isInteger(quantity) || quantity < 1 || button?.disabled) return;
          const error = this.querySelector('[role="alert"]');
          const text = button.textContent;
          error.hidden = true;
          this.busy = true;
          button.disabled = true;
          button.textContent = this.dataset.loading;
          this.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch(this.dataset.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity }, { id: Number(selected.value), quantity }] }) });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || this.dataset.error);
            window.location.assign(this.dataset.cartUrl);
          } catch (failure) {
            error.textContent = failure.message || this.dataset.error;
            error.hidden = false;
            this.busy = false;
            button.disabled = false;
            button.textContent = text;
            this.removeAttribute('aria-busy');
          }
        }, { signal: this.abortController.signal });
      }
      disconnectedCallback() { this.abortController?.abort(); this.abortController = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["skr-wishlist-design"] && !Shopify.designMode) return;
  try {
    (() => {
  let previousFocus;
  const getDialog = () => document.getElementById('SkrWishlistLogin');
  const closeLogin = () => {
    const dialog = getDialog();
    if (dialog?.open) dialog.close();
  };
  const showLogin = (trigger) => {
    const dialog = getDialog();
    if (!dialog || dialog.open) return;
    previousFocus = trigger;
    dialog.showModal();
    dialog.querySelector('[data-skr-wishlist-login]')?.focus();
  };
  window.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('.wishlist-hero-custom-button, .skr-product__wishlist-slot button, [data-wishlist-slot] button, .wishlisthero-product-page-button-container, #wishlisthero-product-page-button-container, .wishlist-hero-product-app-block button, .header__icon--wishlist, a[href$="#hero-wishlist"], #wishlisthero-floating-launcher-container a');
    const dialog = getDialog();
    if (!trigger || !dialog || dialog.dataset.customer === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showLogin(trigger);
  }, true);
  const initialize = () => {
    const dialog = getDialog();
    if (!dialog) return;
    dialog.querySelectorAll('[data-skr-wishlist-close]').forEach(button => button.addEventListener('click', closeLogin));
    dialog.addEventListener('close', () => previousFocus?.focus());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeLogin();
    });
    let scheduled = false;
    const enhance = () => {
      scheduled = false;
      document.querySelectorAll('.MuiDialog-root:has(.wishlisthero-customer-view-listing)').forEach(modal => {
        modal.classList.add('skr-wishlist-modal');
        const header = modal.querySelector('.wishlist-hero-header');
        if (!header.querySelector('.skr-wishlist-subtitle')) {
          const subtitle = document.createElement('p');
          subtitle.className = 'skr-wishlist-subtitle';
          subtitle.textContent = dialog.dataset.subtitle;
          header.append(subtitle);
        }
        modal.querySelector('.wishlist-hero-header-close')?.setAttribute('aria-label', dialog.dataset.close);
        modal.querySelectorAll('.wishlist-hero-list-card-footer-delete').forEach(button => button.setAttribute('aria-label', dialog.dataset.remove));
        const listing = modal.querySelector('.wishlisthero-customer-view-listing');
        if (listing) {
          const count = listing.querySelectorAll('.wishlist-hero-list-card').length;
          modal.classList.toggle('skr-wishlist-single', count <= 1);
          let heading = listing.querySelector('.skr-wishlist-list-heading');
          if (!heading) {
            heading = document.createElement('div');
            heading.className = 'skr-wishlist-list-heading';
            heading.append(document.createElement('strong'), document.createElement('span'));
            listing.prepend(heading);
          }
          const label = `${count} ${count === 1 ? dialog.dataset.product : dialog.dataset.products}`;
          if (heading.firstElementChild.textContent !== dialog.dataset.saved) heading.firstElementChild.textContent = dialog.dataset.saved;
          if (heading.lastElementChild.textContent !== label) heading.lastElementChild.textContent = label;
        }
        const footer = modal.querySelector('.wishlist-hero-footer');
        if (footer && !footer.querySelector('.skr-wishlist-continue')) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'skr-wishlist-continue';
          button.textContent = dialog.dataset.continue;
          button.addEventListener('click', () => modal.querySelector('.wishlist-hero-header-close')?.click());
          footer.append(button);
        }
      });
    };
    new MutationObserver(records => {
      if (scheduled || !records.some(record => record.type === 'childList')) return;
      scheduled = true;
      requestAnimationFrame(enhance);
    }).observe(document.body, { childList: true, subtree: true });
    enhance();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
